define.alias("ember-intl/helpers/format-time", "preview-grid/helpers/format-time");